<template>
    <div class="transfer-details">
        <TransferDetails :transfer="product" />
        <Divider color="lightGrey" thickness="1" topMargin="xl" bottomMargin="xl" />
        <TransferDescription :transfer="product">
            <template #notifications>
                <Notification icon="InfoCircle">
                    {{ t({ key: 'shared.transfer_vehicle_title_disclaimer' }) }}
                </Notification>

                <Notification
                    v-if="product.DisclaimerDescription"
                    :title="product.DisclaimerTitle ?? undefined"
                    icon="InfoCircle">
                    {{ product.DisclaimerDescription }}
                </Notification>
            </template>
        </TransferDescription>
    </div>
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, computed, PropType } from 'vue';
    import { TransferProduct } from '@/api/Cart/cart.interfaces';
    import { useStore } from '@/store';
    import { cleanTransferImage } from '@/helpers/transfer/transfer';
    import { TransferTrip } from '@/helpers/transfer/transfer.interfaces';
    import Divider from '@ui/components/Divider/Divider.vue';
    import Notification from '@ui/components/Notification/Notification.vue';
    import TransferDescription from '@/components/checkoutPageV3/Sections/Addons/Transfer/Trips/Trip/Shared/TransferDescription/TransferDescription.vue';
    import TransferDetails from '@/components/checkoutPageV3/Sections/Addons/Transfer/Trips/Trip/Shared/TransferDetails/TransferDetails.vue';

    export default defineComponent({
        name: 'TransferModalDetails',
        components: { TransferDetails, TransferDescription, Divider, Notification },
        methods: { t, cleanTransferImage },
        props: {
            product: { type: Object as PropType<TransferProduct>, required: true },
        },
        setup(props) {
            const store = useStore();

            const trip = computed(
                (): TransferTrip =>
                    store.getters['checkout/getTripById'](props.product.TripId)
            );

            return { trip };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Details';
</style>
